import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Navbar.css";
import logo from "../assets/images/logo.png";



import { FaInstagram, FaBars } from "react-icons/fa";

const Navbar: React.FC = () => {
  const location = useLocation();
  const [topBarOpen, setTopBarOpen] = useState(false);
  const [navOpen, setNavOpen] = useState(false);

  return (
    <header>
      {/* Top Info Bar */}
      <div className={`top-bar ${topBarOpen ? "open" : ""}`}>
        <button className="topbar-hamburger" onClick={() => setTopBarOpen(!topBarOpen)}>
          <FaBars />
        </button>

        <div className="top-bar-left">
          <a href="https://www.google.com/maps/place/23%C2%B028'24.0%22N+58%C2%B028'36.1%22E/" target="_blank" rel="noopener noreferrer">
            📍 Amirat Muscat, Oman
          </a>
          <a href="tel:+96895987986">📞 +968 95987986</a>
          <a href="mailto:team@dreamstriphub.com">✉ team@dreamstriphub.com</a>
          <a href="https://www.instagram.com/wajehatalahlam" target="_blank" rel="noopener noreferrer" className="instagram-icon">
            <FaInstagram />
          </a>
        </div>

       <div className="top-bar-right">
            <Link to="/about-us">About Us</Link>
            <Link to="/contact-us">Contact Us</Link>
          </div>

      </div>

      {/* Main Navbar */}
      <div className="hero">
        <nav className="navbar">
          <div className="navbar-logo">
            <img src={logo} alt="Dreamstriphub" />
          </div>

          <button className="hamburger" onClick={() => setNavOpen(!navOpen)}>
            <FaBars />
          </button>
          
          <ul className={`navbar-links ${navOpen ? "open" : ""}`}>
          <li>
              <Link to="/travel-insurance" className={location.pathname === "/travel-insurance" ? "active" : ""}>
                INSURANCE
              </Link>
            </li>
           
            <li>
              <Link to="/hotels" className={location.pathname === "/hotels" ? "active" : ""}>
                HOTELS
              </Link>
            </li>
            <li>
              <Link to="/" className={location.pathname === "/" ? "active" : ""}>
                PACKAGES
              </Link>
            </li>
            <li>
              <Link to="/booking" className={location.pathname === "/booking" ? "active" : ""}>
                FLIGHTS
              </Link>
            </li>
          </ul>
        </nav>

        {/* Background Video */}
        <div className="hero-background">
          <video autoPlay loop muted>
            <source src={"/videos/DreamsTravelVideo.mp4"} type="video/mp4" />
          </video>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
